module.exports = __webpack_public_path__ + "static/media/ML.0e97bb9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/ML.svg
// module id = 313
// module chunks = 0